import { render, staticRenderFns } from "./userManualConsumeRecord.vue?vue&type=template&id=c54a9a9e&scoped=true"
import script from "./userManualConsumeRecord.vue?vue&type=script&lang=ts"
export * from "./userManualConsumeRecord.vue?vue&type=script&lang=ts"
import style0 from "./userManualConsumeRecord.vue?vue&type=style&index=0&id=c54a9a9e&prod&scoped=true&lang=stylus"
import style1 from "./userManualConsumeRecord.vue?vue&type=style&index=1&id=c54a9a9e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54a9a9e",
  null
  
)

export default component.exports